export interface UploadedSourceDraft {
  name: string;
  content: string;
  fileType: string;
  size: number;
  isPdf: boolean;
}

export interface DocumentBatchProgress {
  status: 'running' | 'completed' | 'failed';
  totalSources: number;
  savedCount: number;
  processedCount: number;
  completedCount: number;
  failedCount: number;
  skippedCount: number;
  currentIndex: number;
  currentSourceName: string;
  currentStep: 'saving' | 'processing' | 'skipping' | 'finishing';
  processingStatus: string;
  spinnerText: string;
  startedAt: number;
  averageItemMs: number | null;
  estimatedRemainingMs: number | null;
}

const SPINNER_VERBS_CANADIAN = [
  'Working-Away',
  'Getting-Organized',
  'Sorting-This-Out',
  'Putting-It-Together',
  'Doing-The-Needful',
  'Taking-A-Look',
  'Having-A-Gander',
  'Making-Sense-Of-It',
  'Keeping-It-Moving',
  'Pushing-It-Along',
  'Getting-There',
  'Still-At-Er',
  'Working-Through-It',
  'Taking-Care-Of-It',
  'Making-Progress',
  'Tidying-Things-Up',
  'Keeping-The-Lights-On',
  'Filling-Out-A-Form',
  'Submitting-The-Form',
  'Waiting-For-Approval',
  'Still-Waiting',
  'Waiting-A-Bit-Longer',
  'Definitely-Still-Processing',
  'Checking-Back-Later',
  'Following-Up-Politely',
  'Probably-Getting-It-Done',
  'Almost-Having-It',
  'Just-Giving-Er',
  'Taking-A-Quick-Rip',
  'Calling-It-Good-Enough',
  'Working-On-It-A-Bit',
  'Still-Working-On-It',
  'Working-On-It-A-Little-More',
  'Getting-There-Slowly',
  'Almost-Kinda-There',
  'Doing-Something-About-It',
  'Making-It-Happen',
  'Trying-To-Make-It-Happen',
  'Giving-It-A-Go',
  'Giving-It-Another-Go',
  'Giving-It-One-More-Go',
  'Coming-Back-To-It',
  'Circling-Back-To-It',
  'Leaving-It-For-Later'
] as const;

export function getSpinnerText() {
  const value = SPINNER_VERBS_CANADIAN[Math.floor(Math.random() * SPINNER_VERBS_CANADIAN.length)] ?? SPINNER_VERBS_CANADIAN[0];
  return `${value.replace(/-/g, ' ')}…`;
}

export function formatDuration(ms: number | null) {
  if (!ms || ms <= 0) return 'Calculating…';

  const totalSeconds = Math.max(1, Math.round(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
}